import { useMemo } from "react";
import Select from "react-select";
import { useQuery } from "@tanstack/react-query";
import { fetchMultipleSections } from "services/dropdown";
import { DROPDOWN_STALE_TIME } from "utils/constants";
import { Controller } from "react-hook-form";

const SectionDropdownMultiSelector = ({
  errors,
  control,
  setValue,
  watch,
  mappedData,
}) => {
  const selectedSections = watch("section_ids");

  const {
    data: sections,
    isLoading,
    error,
  } = useQuery(["sectionDropdown"], () => fetchMultipleSections(), {
    keepPreviousData: false,
    staleTime: DROPDOWN_STALE_TIME,
  });

  const optionsList = useMemo(
    () =>
      sections?.data?.data?.map((item) => ({
        value: item.id,
        label: item.section,
      })) || [],
    [sections, mappedData]
  );

  const options = mappedData
    ? optionsList.filter((ele) => !mappedData.includes(ele.label))
    : optionsList;

  if (isLoading) return <div>Loading...</div>;
  if (error) return <div>Error loading sections</div>;

  return (
    <Controller
      name="section_ids"
      control={control}
      rules={{ required: "Sections are required" }}
      render={({ field }) => (
        <Select
          {...field}
          options={options}
          isClearable
          isMulti
          placeholder="Select Sections"
          menuPortalTarget={document.body}
          value={options.filter((option) =>
            selectedSections?.includes(option.value)
          )}
          onChange={(selectedOptions) => {
            const values = selectedOptions
              ? selectedOptions.map((option) => option.value)
              : [];

            const labels = selectedOptions
              ? selectedOptions.map((option) => option.label)
              : [];

            field.onChange(values);
            setValue("section_ids", values);
            setValue("section_names", labels);
          }}
          className={`react-select-container ${
            errors.section_ids ? "is-invalid" : ""
          }`}
          styles={{
            menuPortal: (base) => ({ ...base, zIndex: 9999 }),
            control: (base) => ({
              ...base,
              minHeight: "42px",
              height: "auto",
            }),
            valueContainer: (base) => ({
              ...base,
              maxHeight: "none",
              height: "auto",
              padding: "2px 8px",
            }),
            multiValue: (base) => ({
              ...base,
              maxWidth: "100%",
            }),
          }}
        />
      )}
    />
  );
};

export default SectionDropdownMultiSelector;
